//Library Imports
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import store from 'store';

//Local Imports
import {
  closeOverlay,
  closeCurationSidebar,
  closeArticleSidebarPreview,
  closeDetailProfile,
  closeCreateNewContactSidebar,
  closeCreateNewCampaignSidebar,
  closeCreateAssetSidebar,
  closeEditContactSidebar,
  closeCreateNewListAsider,
  closeAdvancedSearchSidebar,
} from '../../GlobalActions';
import { assetinDraftAlreadyExistClose } from '../../EmailBrowser/actions';
import { PEOPLE_AUDIENCE } from 'constants/actionTypes';
import { useLocation } from 'react-router-dom';

function Overlay() {
  const location = useLocation();
  const isOverlay = useSelector((state) => state.uiReducer.overlay);
  const [state, setState] = useState(0);

  const clickOverlay = () => {
    /**
     * * if confirmation box of published page is open it won't hide the overlay here
     */
    // if (openPublishedConfirmation) return;

    //Incase of creating adhoc email,the assider doesn't close clicking overlay,
    //so there's no need to close the overlay while asider open.
    if (location.pathname === '/campaigns/content' || location.pathname === '/campaigns') return;

    closeCurationSidebar();
    // closeCurationHistory();
    closeOverlay();
    closeArticleSidebarPreview();
    closeDetailProfile();
    assetinDraftAlreadyExistClose();
    closeCreateNewContactSidebar();
    closeCreateNewCampaignSidebar();
    closeCreateAssetSidebar();
    closeEditContactSidebar();
    closeCreateNewListAsider();
    closeAdvancedSearchSidebar();
    if (window.location.pathname.startsWith('/audiences')) {
      store.dispatch({
        type: PEOPLE_AUDIENCE.RESET_EDIT_CONTACT,
      });
    }
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('body').style.paddingRight = 0;
  };

  const overFlowHidden = () => {
    document.body.style.overflow = 'hidden';
  };

  if (isOverlay) {
    overFlowHidden();
  }

  useEffect(() => {
    if (isOverlay) {
      setState(state + 1);
    }
  }, [isOverlay]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <Wrapper>
      <div onClick={clickOverlay} className={`${isOverlay ? 'black-overlay' : ''} `}></div>
    </Wrapper>
  );
}

export default Overlay;

const Wrapper = styled.div`
  .black-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 12;
    /* transition: 0.5s; */
  }
`;
